import { Combobox, Input, InputBase, Loader, Stack, useCombobox } from "@mantine/core";
import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import { Suspense, useState } from "react";
import { TopicNode } from "shared/components/organization/topics/TopicNode";
import { topicsQueryOptions } from "shared/graphql/topics";
import { TopicLikeFragment } from "src/gql/graphql";

export const TopicParentSelect = ({
    initialTopic,
    parentId,
    setParentId,
}: {
    initialTopic?: TopicLikeFragment;
    parentId: string;
    setParentId: (id: string) => void;
}) => {
    const combobox = useCombobox();
    const [showTopicTree, setShowTopicTree] = useState(false);

    const {
        data: { rootTopic },
    } = useSuspenseQuery(topicsQueryOptions.theWholeTree());
    const { data, isLoading } = useQuery({ ...topicsQueryOptions.topic(parentId) });

    const TopicModal = () => {
        return (
            <Stack gap={0}>
                <TopicNode
                    topic={rootTopic}
                    initialExpandedNodes={[rootTopic.id]}
                    isChecked={(t) => t.id == parentId}
                    shouldRenderCheckbox={(topic) => topic.isCategory}
                    checkboxOnChange={(topic) => {
                        setParentId(topic.id);
                        setShowTopicTree(false);
                    }}
                    topicFilter={(it) => it.isCategory && it.id != initialTopic?.id}
                    isDisabled={(it) => it.id == parentId}
                    disabledTooltipLabel="Current selection"
                />
            </Stack>
        );
    };

    return (
        <>
            <Combobox store={combobox}>
                <Combobox.Target>
                    <InputBase
                        component="button"
                        type="button"
                        pointer
                        rightSection={<Combobox.Chevron />}
                        onClick={() => setShowTopicTree(!showTopicTree)}
                        rightSectionPointerEvents="none"
                        label="Parent Category"
                        required
                    >
                        {data?.topic.name || (isLoading ? <Loader /> : <Input.Placeholder>Select parent...</Input.Placeholder>)}
                    </InputBase>
                </Combobox.Target>
            </Combobox>
            {showTopicTree && (
                <Stack mah={300} style={{ overflowY: "auto" }}>
                    <Suspense fallback={<Loader />}>
                        <TopicModal />
                    </Suspense>
                </Stack>
            )}
        </>
    );
};
